module.exports = __webpack_public_path__ + "static/item_template_custom-213505902c8411ddbea90f2e47d9f779.png";